module.exports = __webpack_public_path__ + "static/media/social_google.f36dd377.svg";